module.exports = __webpack_public_path__ + "css/OceanVolt.98894c66.css";